"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useArrowBasedFocusTraversal = exports.handleOutsideClick = exports.focusMatchingItem = void 0;
var _findIndex = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find-index"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _react = require("react");
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _listboxUtils = require("../List/_listboxUtils");
/**
 * Find and focus the next matching candidate item based on typed string.
 */
var focusMatchingItem = exports.focusMatchingItem = function focusMatchingItem( /** String typed by user */
typedString, /** List of focusable candidate nodes */
focusableNodes) {
  var _a, _b;
  if (!(focusableNodes === null || focusableNodes === void 0 ? void 0 : focusableNodes.length)) return;
  // Get index of current active element
  var activeIndex = (0, _findIndex.default)(focusableNodes).call(focusableNodes, function (menuItem) {
    return menuItem === (document === null || document === void 0 ? void 0 : document.activeElement);
  });
  var foundIndex = -1;
  var isNextMatch = function isNextMatch(menuItem) {
    var menuItemText = menuItem === null || menuItem === void 0 ? void 0 : menuItem.innerText;
    return menuItemText && (typedString === null || typedString === void 0 ? void 0 : (0, _trim.default)(typedString).call(typedString)) && (0, _listboxUtils.matcherMethodIgnoreCase)(menuItemText, typedString) && (document === null || document === void 0 ? void 0 : document.activeElement) !== menuItem;
  };
  // Search after active index
  for (var i = activeIndex + 1; i < focusableNodes.length; i += 1) {
    if (isNextMatch(focusableNodes[i])) {
      foundIndex = i;
      break;
    }
  }
  // Search before active index
  if (foundIndex === -1) {
    for (var _i = 0; _i < activeIndex; _i += 1) {
      if (isNextMatch(focusableNodes[_i])) {
        foundIndex = _i;
        break;
      }
    }
  }
  if (foundIndex === -1) return;
  // Focus matched item if found
  (_b = (_a = focusableNodes[foundIndex]) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
};
/**
 * Handles the outside click event by evaluating overlay conditions
 * and invoking provided functions.
 *
 * @returns {boolean} - The result based on the evaluation of conditions.
 */
var handleOutsideClick = exports.handleOutsideClick = function handleOutsideClick( /** The click event. */
event, /** A function to delegate handling to if provided. */
delegate, /** A function to call when overlay conditions are not met. */
onHide) {
  var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var _a, _b, _c, _d, _e, _f;
  if (typeof delegate === 'function') {
    return delegate(event);
  }
  var target = event.target;
  var leafClicked = !!(target && ((_a = target === null || target === void 0 ? void 0 : target.closest) === null || _a === void 0 ? void 0 : _a.call(target, '[data-nui-widgets="menuitem-leaf"]')) !== null);
  var overlayClicked = !!(target && ((_b = target === null || target === void 0 ? void 0 : target.closest) === null || _b === void 0 ? void 0 : _b.call(target, '[data-nui-widgets="menu-overlay"]')) !== null);
  var nodeClicked = !!(target && ((_c = target === null || target === void 0 ? void 0 : target.closest) === null || _c === void 0 ? void 0 : _c.call(target, '[data-nui-widgets="menuitem-node"]')) !== null);
  var isLevelDiff = !((((_d = target === null || target === void 0 ? void 0 : target.getAttribute) === null || _d === void 0 ? void 0 : _d.call(target, 'data-level')) || ((_f = (_e = target === null || target === void 0 ? void 0 : target.parentElement) === null || _e === void 0 ? void 0 : _e.getAttribute) === null || _f === void 0 ? void 0 : _f.call(_e, 'data-level'))) === "".concat(level));
  if (!leafClicked && !nodeClicked && !overlayClicked) {
    onHide === null || onHide === void 0 ? void 0 : onHide();
    return false;
  }
  return !!(leafClicked || nodeClicked && isLevelDiff);
};
/**
 * Hook for handling arrow-based focus traversal and menu opening.
 *
 * @returns {Object} An object with the `moveFocusAndOpenNew` function.
 */
var useArrowBasedFocusTraversal = exports.useArrowBasedFocusTraversal = function useArrowBasedFocusTraversal() {
  var autoOpenInterval;
  var autoOpenTries = 0;
  var moveFocusAndOpenNew = function moveFocusAndOpenNew(target, focusDirection) {
    var _a;
    // move focus to the menu that is left/right of the target
    var tabEvent = new KeyboardEvent('keydown', {
      bubbles: true,
      cancelable: true,
      key: focusDirection === 'right' ? 'ArrowRight' : 'ArrowLeft',
      keyCode: focusDirection === 'right' ? _keycode.default.codes.right : _keycode.default.codes.left
    });
    (_a = target === null || target === void 0 ? void 0 : target.dispatchEvent) === null || _a === void 0 ? void 0 : _a.call(target, tabEvent);
    //  at regular intervals, check if focus is moved
    autoOpenInterval = setInterval(function () {
      var _a, _b, _c;
      autoOpenTries += 1;
      if (autoOpenTries > 4) {
        clearInterval(autoOpenInterval);
      }
      // if focus is moved, check focused element is a menu button
      if (document.activeElement !== target) {
        clearInterval(autoOpenInterval);
        if (((_a = document === null || document === void 0 ? void 0 : document.activeElement) === null || _a === void 0 ? void 0 : _a.tagName) === 'BUTTON') {
          // click the menu button
          (_c = (_b = document === null || document === void 0 ? void 0 : document.activeElement) === null || _b === void 0 ? void 0 : _b.click) === null || _c === void 0 ? void 0 : _c.call(_b);
        }
      }
    }, 0);
  };
  (0, _react.useEffect)(function () {
    return clearInterval(autoOpenInterval);
  }, []);
  return {
    moveFocusAndOpenNew: moveFocusAndOpenNew
  };
};